// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__19oPu","ranges":"BmiRanges_ranges__1L_Il"};